import React, { useState, useEffect } from "react"
import _ from "lodash"

import { alphanum } from "components/table/lib/sort"
import { field_attrs } from "components/table/lib/column-field"

import { CheckboxInput, ListboxInput } from "components/table/carousel/inputs"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { ListboxSection_s, ListboxHeaderSort_s, SelectAllCheckbox_s } from "styles/input-styles"

const Detailed = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const emptyRecord = {}
  const [sortDirty, setSortDirty] = useState<boolean>(false);
  const [sortAsc, setSortAsc] = useState<boolean>(true);
  const [data, setData] = useState<object|null>(props.rowData[props.field]);
  const [showSelected, setShowSelected] = useState<boolean>(props.rowData[props.field].items?.length > 0);

  useEffect(() => {
    if (!props['rowData'][props.field]) setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    if (field === 'items'){
      let items = val
      if (items && items[0] === "") items.shift();
      items = items.map(item => { return { 'rentRollId': item }})
      nextData[field] = items
    } else {
      nextData[field] = val
    }
    setData(nextData);
    props.persist({...nextData}, 'tenantgroupdetail', props.rowData)
  }

  const attrs           = (field) => field_attrs('tenantgroup')(field)(props.rowData, props)
  let rentRolls         = props.namedItems['rentroll'];
  let tenantGroupsData  = _.cloneDeep(data);
  tenantGroupsData      = tenantGroupsData && tenantGroupsData['items'] ? tenantGroupsData['items'].map(item => item.rentRollId) : null

  if (showSelected && tenantGroupsData){
    rentRolls = rentRolls.filter(rentroll => tenantGroupsData.includes(rentroll.rentrollid));
  }

  function selectAll():void {
    data && data['items'] && data['items'].length === rentRolls.length ? updateData([], 'items') : updateData(rentRolls.map(rentroll => rentroll.rentrollid), 'items')
  }

  if (sortDirty){
    sortAsc ? rentRolls.sort((a, b) => alphanum(a.suite, b.suite)) : rentRolls.sort((a, b) => alphanum(b.suite, a.suite))
  }

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Show Selected</label>
          <CheckboxInput className="automated" data={{showSelected}} field='showSelected' persist={(val, field) => setShowSelected(val)} />
        </div>
        <ListboxSection_s>
          <ListboxHeaderSort_s>
            <label>Tenants</label>
            <a onClick={(e) => { sortDirty === false ? setSortDirty(true) : setSortAsc(!sortAsc)}}>
              { !sortDirty && <i className="pi pi-sort-alt" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && sortAsc && <i className="pi pi-sort-amount-down" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && !sortAsc && <i className="pi pi-sort-amount-up" style={{height: '18px', width: '18px'}} /> }
            </a>
          </ListboxHeaderSort_s>
          <SelectAllCheckbox_s className="automated select-all-rent-rolls" data={{allSelected: tenantGroupsData ? tenantGroupsData.length === rentRolls.length : false}} field='allSelected' persist={selectAll} />
          <ListboxInput
            className="automated"
            data={{"items": tenantGroupsData}}
            attrs={attrs}
            field="items"
            multiple={true}
            persist={updateData}
            options={rentRolls.map(rentroll => { return {label: `${rentroll.sortorder} - ${rentroll.suite}: ${rentroll.tenant}`, value: rentroll.rentrollid}})}
          />
        </ListboxSection_s>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default Detailed
